import { render } from "./UserManual.vue?vue&type=template&id=817b7c1e&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"

import "./UserManual.vue?vue&type=style&index=0&id=817b7c1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817b7c1e"]])

export default __exports__